module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: _vm.componentId
  }, [_c('button', {
    staticClass: "button small",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Segment attributes")]), _c('label', [_vm._v("Attributes")]), _c('Attributes', {
    attrs: {
      "save-action": _vm.updateAttribute,
      "delete-action": _vm.deleteAttribute
    },
    model: {
      value: (_vm.body.attributes),
      callback: function($$v) {
        _vm.$set(_vm.body, "attributes", $$v)
      },
      expression: "body.attributes"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7723094c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/SegmentAttributesReveal.vue
// module id = 2451
// module chunks = 1